import React, { useEffect, useState } from 'react';

//*MUI
import { Box, Modal } from '@mui/material';
import CustomInput from '../../../Subcomponents/CustomInput';

//*files
import cssClasses from './AddHoldDetailsModal.module.css';
import Close from '../../Icons/Close';
import Button from '../../../Subcomponents/Button';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function AddHoldDetailsModal({
  open,
  handleClose,
  isEdit,
  handleSave,
  selectedHoldDetails,
}) {
  const [holdData, setHoldData] = useState({
    HoldType: '',
    // description: ''
  });
  const [helperText, setHelperText] = useState({
    HoldType: '',
    // description: ''
  });

useEffect(() => {
  if (selectedHoldDetails) {
    setHoldData({
      HoldType: selectedHoldDetails?.HoldType || '',
    });
  }
}, [selectedHoldDetails]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>
                    {isEdit ? 'Edit Hold Type' : 'Add Hold Type'}
                  </Box>
                </Box>
              </Box>
              <Box
                ml={'auto'}
                mt={1}
                onClick={handleClose}
                style={{ cursor: 'pointer' }}
              >
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box
              paddingX={'3rem'}
              backgroundColor={'#F9FAFB'}
              display={'flex'}
              justifyContent={'space-between'}
              gap={'2rem'}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '3rem',
                  justifyContent: 'space-evenly',
                  margin: '2rem 0rem',
                }}
              >
                <div>
                  <CustomInput
                    handleChange={(newVal) => {
                      newVal = newVal.trimStart();
                      setHoldData((pre) => {
                        pre.HoldType = newVal.slice(0, 40);
                        return { ...pre };
                      });

                      if (newVal !== '') {
                        setHelperText((pre) => {
                          pre.HoldType = '';
                          return { ...pre };
                        });
                      } else {
                        setHelperText((pre) => {
                          pre.HoldType = 'Please enter Hold type!';
                          return { ...pre };
                        });
                      }
                    }}
                    value={holdData?.HoldType}
                    placeholder={'Enter Hold type'}
                    inputType={'text'}
                    helperText={helperText?.HoldType}
                    label='Hold Type'
                    mandatory
                  />
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box
              className={cssClasses.flexRow}
              style={{ justifyContent: 'end' }}
            >
              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: '#006AFF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  disable={holdData?.HoldType === ''}
                  btnName={'Save'}
                  clicked={() => {
                    handleSave({ HoldType: holdData.HoldType.trim() }, isEdit);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AddHoldDetailsModal;
